import {
  boticarioTheme,
  eudoraTheme,
  ouiTheme,
  quemDisseBereniceTheme,
  gbInstitucionalTheme,
} from '@grupoboticario/flora'

const floraTheme = (theme: string) => {
  if (!theme) {
    return gbInstitucionalTheme
  }

  switch (theme.toUpperCase()) {
    case 'EUD':
    case 'EUDORA':
      return eudoraTheme

    case 'BOT':
    case 'BOTICARIO':
      return boticarioTheme

    case 'OUI':
      return ouiTheme

    case 'EAM':
    case 'EUAMOMAKE':
      return quemDisseBereniceTheme

    default:
      return gbInstitucionalTheme
  }
}
export { floraTheme }
